/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FlashOfferCell_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FlashOffersList_lists$ref: FragmentReference;
declare export opaque type FlashOffersList_lists$fragmentType: FlashOffersList_lists$ref;
export type FlashOffersList_lists = {|
  +flashOffers: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: FlashOfferCell_offer$ref,
      |}
    |}>
  |},
  +$refType: FlashOffersList_lists$ref,
|};
export type FlashOffersList_lists$data = FlashOffersList_lists;
export type FlashOffersList_lists$key = {
  +$data?: FlashOffersList_lists$data,
  +$fragmentRefs: FlashOffersList_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlashOffersList_lists",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "OfferConnection",
      "kind": "LinkedField",
      "name": "flashOffers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FlashOfferCell_offer"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "flashOffers(first:50)"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '54ba5c7ffd517ba7b601c72b8b292727';

module.exports = node;
